export function msToTime(duration: number) {
  let millis = parseInt(String((duration % 1000) / 100))
    , seconds = parseInt(String((duration / 1000) % 60))
    , minutes = parseInt(String((duration / (1000 * 60)) % 60))
    , hours = parseInt(String((duration / (1000 * 60 * 60) % 24)))

  const hh = (hours < 10) ? "0" + hours : hours;
  const mm = (minutes < 10) ? "0" + minutes : minutes;
  const ss = (seconds < 10) ? "0" + seconds : seconds;
  const ms = (millis < 100)
    ? "0" + millis
    : (millis < 10)
      ? "00" + millis
      : millis

  return `${hh}:${mm}:${ss}.${ms}`
}